let styleInjected = false;

const injectStyle = () => {
  if (styleInjected) return;
  if (typeof document === 'undefined') return;
  const style = document.createElement('style');
  style.id = 'storeeel-video-download-guard';
  style.textContent = `
    .storeeel-campaign-container video::-webkit-media-controls-download-button,
    .storeeel-campaign-container video::-internal-media-controls-download-button,
    .storeeel-campaign-container video::-webkit-media-controls-overlay-play-button,
    .storeeel-modal video::-webkit-media-controls-download-button,
    .storeeel-modal video::-internal-media-controls-download-button,
    .storeeel-modal video::-webkit-media-controls-overlay-play-button,
    video.storeeel-content-movie::-webkit-media-controls-download-button,
    video.storeeel-content-movie::-internal-media-controls-download-button,
    video.storeeel-content-movie::-webkit-media-controls-overlay-play-button,
    video.storeeel-movie::-webkit-media-controls-download-button,
    video.storeeel-movie::-internal-media-controls-download-button,
    video.storeeel-movie::-webkit-media-controls-overlay-play-button {
      display: none !important;
    }
  `;
  document.head.appendChild(style);
  styleInjected = true;
};

export const applyVideoDownloadSafeguards = (videoEl) => {
  if (!videoEl) return;

  injectStyle();

  try {
    videoEl.controls = false;
  } catch { void 0; }

  if (typeof videoEl.removeAttribute === 'function') {
    videoEl.removeAttribute('controls');
  }
  videoEl.setAttribute('controlslist', 'nodownload noremoteplayback nofullscreen');
  videoEl.disablePictureInPicture = true;
  videoEl.disableRemotePlayback = true;
};
